var _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _linearGradient5, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconCaptcha(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 510 510",
    height: 512,
    viewBox: "0 0 510 510",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 162,
    x2: 465.015,
    y1: 162,
    y2: 465.015
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0b799d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#07485e"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 366.185,
    x2: 123.183,
    y1: 385.815,
    y2: 142.813
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#07485e",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#03232e"
  }))), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 301.043,
    x2: 412.491,
    y1: 156.957,
    y2: 268.404
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#76e2f8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#48b2e3"
  }))), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 145.711,
    x2: 267.531,
    y1: 145.534,
    y2: 267.355
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b5dbff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#48b2e3"
  }))), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 204.706,
    x2: 204.706,
    y1: 300,
    y2: 409
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#edf5ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d5e8fe"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 255,
    cy: 255,
    fill: "url(#SVGID_1_)",
    r: 255
  }), /*#__PURE__*/React.createElement("path", {
    d: "m509.729 266.519-130.007-130.007c-26.116-27.471-61.152-44.388-100.36-49.987l-41.448-25.996c-10.064-6.312-21.139-1.079-21.139 10.8v18.22c-76.281 18.322-132.97 85.539-131.97 167.587.011.908-.077 7.698-.034 10.659l-.694 90.761c.06 4.166-.281 7.736 2.279 10.339.764.776 87.092 86.64 140.264 139.524 9.32 1.032 18.785 1.58 28.38 1.58 136.971.001 248.704-107.995 254.729-243.48z",
    fill: "url(#SVGID_2_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m443.438 236.948h-17.183c-8.971-85.429-80.953-152.673-168.324-154.133-1.986-.033-3.961-.02-5.931.014v60.002c.997-.026 1.997-.041 3-.041 55.725 0 102.09 40.838 110.749 94.158h-18.77c-11.88 0-19.114 13.076-12.802 23.14l48.229 76.897c5.922 9.443 19.681 9.443 25.604 0l48.229-76.897c6.313-10.064-.921-23.14-12.801-23.14z",
    fill: "url(#SVGID_3_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m314.811 106.757-76.898-48.229c-10.064-6.312-23.14.922-23.14 12.802v16.219c-76.281 18.322-132.97 87.54-131.97 169.589.164 13.425 2.003 26.563 5.291 39.215h62.635c-4.93-12.336-7.725-25.727-7.927-39.702-.699-48.405 29.43-89.995 71.971-106.388v17.527c0 11.88 13.076 19.114 23.14 12.802l76.898-48.229c9.443-5.925 9.443-19.683 0-25.606z",
    fill: "url(#SVGID_4_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m319.829 369.149c-8.009-8.009-19.818-10.742-30.602-7.278-11.914 3.827-24.693 5.71-37.957 5.278-32.082-1.046-60.811-15.73-80.633-38.364l15.73-10.185c9.972-6.456 8.938-21.365-1.83-26.382l-82.277-38.338c-10.104-4.708-21.653 2.77-21.492 13.915l1.307 90.761c.171 11.878 13.35 18.924 23.322 12.467l15.354-9.941c30.985 38.768 77.938 64.663 129.484 66.062 20.231.549 39.716-2.411 57.884-8.316 21.207-6.891 27.477-33.912 11.71-49.679z",
    fill: "url(#SVGID_5_)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCaptcha);
export default __webpack_public_path__ + "static/media/icon-captcha.d2a0b8b7fe67f0b26d6f68b4fbdff719.svg";
export { ForwardRef as ReactComponent };